import usePrivateAxios from "@/common/api/usePrivateAxios"
import { useMutation } from "@tanstack/react-query"
import { AxiosResponse } from "axios"
import { CreateScrapRuleSchema } from "../../schemas/maintenanceScrapRules/createScrapRule.schema"

interface UseUpdateScrapRuleProps {
  scrapRuleId?: string
  onSuccess?: (response: AxiosResponse) => void
  onError?: (error: any) => void
}

const useUpdateScrapRule = ({ scrapRuleId, onSuccess, onError }: UseUpdateScrapRuleProps) => {
  const privateAxios = usePrivateAxios()
  return useMutation({
    mutationKey: ['updateScrapRule'],
    mutationFn: async (form: CreateScrapRuleSchema) => {
      const payload = {
        display_name: form.display_name,
        maximum_mileage_condition: form.has_mileage ? form.maximum_mileage_condition : undefined,
        maximum_usage_hours_condition: form.has_hours ? form.maximum_usage_hours_condition : undefined,
        maximum_usage_time_in_years_codition: form.has_years ? form.maximum_usage_time_in_years_condition : undefined,
        equipment_category_ids: form.equipment_category_ids ? form.equipment_category_ids.map((item) => item.value) : undefined,
        branch_ids: form.branch_ids ? form.branch_ids.map((item) => item.value) : undefined,
        manufacturer_ids: form.manufacturer_ids ? form.manufacturer_ids.map((item) => item.value) : undefined,
        equipment_model_ids: form.equipment_model_ids ? form.equipment_model_ids.map((item) => item.value) : undefined,
        equipment_ids: form.equipment_ids ? form.equipment_ids.map((item) => item.value) : undefined,
      }

      return privateAxios.put(`/maintenance/scrap_rules/${scrapRuleId}`, { scrap_rule: payload })
    },
    onSuccess,
    onError,
  })
}

export default useUpdateScrapRule

